export const STATISTICS_VIEW = 'statistics_view';
